import Styled from 'styled-components';

const Background = Styled.div`
    width: 100%;
    min-height: 100vh;
    position: relative;
    background-image: url(${props => props.imageurl});
    background-repeat: no-repeat;
    background-attachment: initial;
    background-position: center bottom;
    background-size: cover;

    @media only screen and (max-width: 767px){
        min-height: 100vh;
    }
`;

const AuthWrapper = Styled.div`
    min-height: 100vh;

    .auth-contents{
        position: relative;
        top: 5vh;
        right: 5%;
        display: block;
        background: #fff;
        float: right;
        padding: 10px 20px 40px 20px;
        border-radius: 20px;
        box-shadow: 0 16px 45px rgba(15, 23, 42, 0.16);

        .auth-contents-logo{
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;
            margin-bottom: 8px;
        }

        .auth-contents-form{
            display: flex;

            form{
                width: 360px;

                .login-title{
                    margin-bottom: 24px;
                    color: #172554;
                    font-size: 20px;
                    font-weight: 600;
                    line-height: 1.35;
                }

                .color-secondary {
                    color: #F58826;
                }

                .ant-form-item-control-input {
                    min-height: 48px;
                }

                .auth-form-action{
                    margin-bottom: 20px;
                    display: flex;
                    justify-content: space-between;
                }

                .auth-form-action-error{
                    margin-bottom: 20px;
                }

                .btn-signin {
                    background: #215E97;
                }
            }
        }
    }

    button{
        &.btn-signin{
            min-width: 185px;
        }

        &.ant-btn-lg{
            font-size: 14px;
            font-weight: 500;
            height: 48px;
        }
    }

    @media only screen and (max-width: 767px){
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;

        .auth-contents{
            top: auto;
            right: auto;
            float: none;
            width: min(100%, 420px);

            .auth-contents-logo{
                justify-content: center;
            }

            .auth-contents-form form{
                width: 100%;
            }
        }
    }
`;

export { Background, AuthWrapper };
